import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';
import { books_category } from '../ProData';

const categoryModernStyles = `
  .home-category-section {
    background: #ffffff;
    border-radius: 22px;
    border: 1px solid #e2e8f0;
    padding: 36px 32px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
    margin-bottom: 2rem;
  }

  .home-category-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 28px;
    flex-wrap: wrap;
    gap: 14px;
  }

  .home-category-title-group {
    max-width: 680px;
  }

  .home-category-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #e0f2fe;
    color: #0284c7;
    font-size: 0.76rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    padding: 4px 10px;
    border-radius: 12px;
    margin-bottom: 8px;
  }

  .home-category-title {
    font-size: 1.85rem;
    font-weight: 800;
    color: #063547;
    margin-bottom: 6px;
    letter-spacing: -0.3px;
  }

  .home-category-subtitle {
    font-size: 0.96rem;
    color: #64748b;
    margin-bottom: 0;
    line-height: 1.5;
  }

  .btn-view-all-cats {
    background: #f1f5f9;
    color: #063547 !important;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 8px 18px;
    font-size: 0.88rem;
    font-weight: 700;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
  }

  .btn-view-all-cats:hover {
    background: #063547;
    color: #ffffff !important;
    border-color: #063547;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(6, 53, 71, 0.2);
  }

  .category-cards-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 12px;
  }

  .category-item-card {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1.5px solid #e2e8f0;
    border-radius: 16px;
    padding: 22px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: all 0.25s ease;
    cursor: pointer;
    min-height: 270px;
    position: relative;
    overflow: hidden;
  }

  .category-item-card:hover {
    transform: translateY(-5px);
    border-color: #0bb6d7;
    box-shadow: 0 10px 28px rgba(11, 182, 215, 0.15);
    background: #ffffff;
  }

  .category-card-top {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 14px;
  }

  .category-icon-wrapper {
    width: 58px;
    height: 58px;
    border-radius: 14px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 6px;
  }

  .category-icon-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .category-card-name {
    font-size: 1.12rem;
    font-weight: 700;
    color: #063547;
    line-height: 1.3;
    margin-bottom: 2px;
  }

  .category-card-desc {
    font-size: 0.88rem;
    color: #64748b;
    line-height: 1.5;
    margin-bottom: 16px;
    flex-grow: 1;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .category-card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
    border-top: 1px solid #e2e8f0;
  }

  .category-explore-link {
    font-size: 0.84rem;
    font-weight: 700;
    color: #0284c7;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: gap 0.15s ease;
  }

  .category-item-card:hover .category-explore-link {
    gap: 10px;
    color: #0bb6d7;
  }

  .category-pill-tag {
    font-size: 0.72rem;
    font-weight: 600;
    color: #475569;
    background: rgba(0, 0, 0, 0.04);
    padding: 2px 8px;
    border-radius: 6px;
  }

  @media (max-width: 992px) {
    .category-cards-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 600px) {
    .home-category-section {
      padding: 24px 18px;
    }
    .home-category-title {
      font-size: 1.45rem;
    }
    .category-cards-grid {
      grid-template-columns: 1fr;
    }
  }
`;

export default function BookCategoryCaroselHome() {
  const navigate = useNavigate();
  const [booksCategory, setBooksCategory] = useState([]);

  useEffect(() => {
    const tempBooks = books_category.filter((item) => item.categoryDisplay === 'Yes');
    setBooksCategory(tempBooks);
  }, []);

  // Split categories into chunks of 3 for desktop slider
  const chunkSize = 3;
  const categoryChunks = [];
  for (let i = 0; i < booksCategory.length; i += chunkSize) {
    categoryChunks.push(booksCategory.slice(i, i + chunkSize));
  }

  const handleCategoryClick = (categoryName) => {
    navigate(`/search?topic=BookCategory&q=${encodeURIComponent(categoryName)}`);
  };

  return (
    <div className="home-category-section">
      <style>{categoryModernStyles}</style>

      {/* Header with Title & All Categories Link */}
      <div className="home-category-header">
        <div className="home-category-title-group">
          <div className="home-category-badge">
            <i className="fa fa-th-large"></i>
            <span>Curated Academic Repository</span>
          </div>
          <h2 className="home-category-title">Featured Academic Disciplines</h2>
          <p className="home-category-subtitle">
            Explore 65 distinct theological and philosophical disciplines comprising over 2,000 specific subject classifications.
          </p>
        </div>

        <Link to="/categories" className="btn-view-all-cats">
          <span>View All 65 Categories</span>
          <i className="fa fa-arrow-right"></i>
        </Link>
      </div>

      {/* Carousel of Category Cards */}
      <Carousel
        interval={5500}
        pause="hover"
        indicators={categoryChunks.length > 1}
        controls={false}
      >
        {categoryChunks.map((chunk, idx) => (
          <Carousel.Item key={idx}>
            <div className="category-cards-grid">
              {chunk.map((item, i) => (
                <div
                  className="category-item-card"
                  key={item.name + i}
                  onClick={() => handleCategoryClick(item.name)}
                  title={`Explore books in ${item.name}`}
                >
                  <div>
                    <div className="category-card-top">
                      <div className="category-icon-wrapper">
                        <img
                          className="category-icon-img"
                          src={item.categoryImage}
                          alt={item.name}
                          onError={(e) => {
                            e.target.src = "https://cdn-icons-png.flaticon.com/512/3389/3389081.png";
                          }}
                        />
                      </div>
                      <div>
                        <div className="category-card-name">{item.name}</div>
                        <span className="category-pill-tag">Scholarly Collection</span>
                      </div>
                    </div>

                    <div className="category-card-desc">
                      {item.categoryDesc || `Curated academic collection of books, treatises, monographs, and research papers in ${item.name}.`}
                    </div>
                  </div>

                  <div className="category-card-footer">
                    <span className="category-explore-link">
                      <span>Explore Books</span>
                      <i className="fa fa-arrow-right"></i>
                    </span>
                    <span className="category-pill-tag">
                      <i className="fa fa-search me-1"></i> Search
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
